import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ReceiptAddChild from "./ReceiptAddChild";
import { useLocation } from "react-router-dom";

const ReceiptAdd = () => {
  const { state } = useLocation();
  const subscriberRecord = state;
  return (
    <MainTemplate>
      <CardBackground>
        <ReceiptAddChild subscriberRecord={subscriberRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default ReceiptAdd;
